import { PublicClientApplication } from '@azure/msal-browser';

const oidcConfig = {
    auth: {
      clientId: `${process.env.REACT_APP_SSO_CLIENT_ID}`, // This is the ONLY mandatory field that you need to supply.
      authority: `${process.env.REACT_APP_SSO_Authorities}`, // Replace with your tenant and user flow
      knownAuthorities: [`${process.env.REACT_APP_SSO_kNOWN_Authorities}`], // Replace with your B2C domain
      redirectUri: `${process.env.REACT_APP_SSO_REDIRECT_URL}`, // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
      postLogoutRedirectUri: `${process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URL}`, // Indicates the page to navigate after logout.


      navigateToLoginRequestUrl: false, // If 'true', will navigate back to the original request location before processing the auth code response.
    },
  
    cache: {
      cacheLocation: 'localStorage', // Configures cache location. 'sessionStorage' is more secure, but 'localStorage' gives you SSO between tabs.
      storeAuthStateInCookie: true, // Set this to 'true' if you are having issues on IE11 or Edge
    }
  }




   const loginRequest = {
    scopes: ['openid'] // Replace with the scopes you need
  };
   
  const msalInstance = new PublicClientApplication(oidcConfig);

  // Initialize MSAL
  await msalInstance.initialize(); // This line ensures proper initialization

  export {loginRequest,msalInstance};


   